import React from 'react';
import { Alert, styled } from '@mui/material';
import type { AlertProps } from '@mui/material';
import { Colors, ColorsType } from '../../theme';

const SEVERITY_COLORS: Record<string, { background: ColorsType; icon: ColorsType }> = {
    info: { background: Colors.secondarySoft, icon: Colors.primary },
    success: { background: Colors.successBackground, icon: Colors.primary },
    warning: { background: Colors.warningBackground, icon: Colors.primary },
    error: { background: Colors.errorBackground, icon: Colors.error },
};

const StyledAlert = styled(Alert)<{ severity?: string }>(({ severity = 'info' }) => {
    const colors = SEVERITY_COLORS[severity] ?? SEVERITY_COLORS.info;
    return {
        borderRadius: 8,
        backgroundColor: colors.background,
        '& .MuiAlert-message': {
            fontFamily: 'Outfit',
        },
        '& .MuiAlert-icon': {
            color: colors.icon,
        },
    };
});

export default function InlineAlert(props: AlertProps) {
    return <StyledAlert {...props} />;
}
